export default "__VITE_ASSET__14adee48__"